import { useEffect, useRef } from 'react';

export interface ISrEvent {
    Key: string;
    dbObjectName: string;
    ID: number;
    IDs: number[];
    Success: boolean;
    ObserverName: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Data: any;

    HasKey: () => boolean;

    KeyContainsName: (name: string) => boolean;
}

type EventName = 'Wizard.Complete' /* there are others here add as we go */

type BindGlobalEvent = (eventName: EventName, event: ISrEvent) => void;

declare const starrez: {
    BindEvent: (callback: BindGlobalEvent, observerKey?: string) => string;
    UnbindEvent: (observerKey: string) => void;
};

const isSRWAttached = () => typeof starrez !== 'undefined';

export const useSRWGlobalEvent = (callback: BindGlobalEvent, key: string) => {
    const ref = useRef('');

    useEffect(() => {
        const isAttached = isSRWAttached();

        if (isAttached) {
            ref.current = starrez.BindEvent(callback, key);
        }

        return () => {
            if (isAttached) {
                starrez.UnbindEvent(ref.current);
            }
        };
    }, []);
};
